import React from 'react';
import { Link } from 'react-router-dom';

// Cell renderer for project name with link
const ProjectNameRenderer = (params) => {
  if (!params.data || !params.data.project) return null;
  const project = params.data.project;
  return (
    <Link to={`/crm/projects/${project.id}`} target="_blank" rel="noopener noreferrer" className="tw-text-blue-600">
      {project.name}
    </Link>
  );
};

export default ProjectNameRenderer;